// Wanneer een keuze botst met een andere optie, beweegt die andere optie mee
// (zie option-conflict-resolution.ts). Dit bepaalt wat de klant daarvan ziet.
// Verpakkings- en productiedetails (bundelen, sealen, pallet, drukmethode)
// veranderen stil: een browservraag "Aftellen en bundelen: per 250 → per 25.
// Doorgaan?" was onduidelijk en liet klanten hun eigen keuze afbreken.

export const QUIET_AUTO_CHANGE_OPTION_IDS = new Set([
  'bundle', 'standard_bundle', 'cross_bundle', 'sealed', 'pallet_delivery', 'box_delivery',
  'delivery', 'sheet_size', 'printingmethod', 'printing_method', 'flexibleprintingmethod',
  'packaging_extras', 'customer_packing_option', 'clean_cut', 'plano_delivery',
]);

type NoticeOption = {
  id: string;
  name?: string;
  label?: string;
  hidden?: boolean;
  values?: Array<{ value: unknown; label?: string }>;
};

export type AutoChangeNotice = { title: string; lines: string[] };

const TITLES: Record<string, string> = {
  nl: 'Aangepast zodat je keuze leverbaar is',
  en: 'Adjusted so your choice can be produced',
  de: 'Angepasst, damit Ihre Auswahl lieferbar ist',
  fr: 'Ajusté pour que votre choix soit réalisable',
};

export const UNDO_LABELS: Record<string, string> = {
  nl: 'Ongedaan maken', en: 'Undo', de: 'Rückgängig', fr: 'Annuler',
};

export function buildAutoChangeNotice(input: {
  changes: Array<[string, unknown]>;
  previous: Record<string, unknown>;
  options: NoticeOption[];
  locale?: string;
  isHiddenForCustomer?: (optionId: string) => boolean;
}): AutoChangeNotice | null {
  const lang = String(input.locale || 'nl').slice(0, 2).toLowerCase();
  const lines = input.changes.flatMap(([id, next]) => {
    if (QUIET_AUTO_CHANGE_OPTION_IDS.has(id) || input.isHiddenForCustomer?.(id)) return [];
    const option = input.options.find((candidate) => candidate?.id === id || candidate?.name === id);
    if (!option || option.hidden) return [];
    const label = (value: unknown) => String(option.values?.find((candidate) => String(candidate?.value) === String(value))?.label || value || '—');
    return [`${option.label || option.name || id}: ${label(input.previous[id])} → ${label(next)}`];
  });
  return lines.length ? { title: TITLES[lang] || TITLES.nl, lines } : null;
}
